import { Component, OnInit } from '@angular/core';
import {Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {FormularioService} from '../../services/formulario.service'
import {Message} from '../../models';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { FirestoreService } from 'src/app/services/firestore.service';
import { FirestorageService } from 'src/app/services/firestorage.service';

@Component({
  selector: 'contactForm',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {

  messages: Message[] = [];

  newMessage: Message;

 

  private path = 'Messages/';

  loading: any;


 
  constructor(public firestoreService: FirestoreService, public loadingController: LoadingController, public toastController: ToastController, public alertController: AlertController, public firestorageService: FirestorageService) { 
  
  }

  ngOnInit() {
    this.nuevo();
  }

  async guardarMessage(){
    this.presentLoading();
    const path = 'Messages';
    const name = this.newMessage.name;      
    this.firestoreService.createDoc(this.newMessage, this.path, this.newMessage.id).then( res=> {
    this.loading.dismiss();
    this.presentToast('guardado con exito');
    }).catch(error =>{
    this.presentToast('no se pudo guardar');
  });  
  }


  nuevo(){
    this.newMessage = {
      email: "",
      name: "",
      message: "",
      id: this.firestoreService.getId(),
      img: "",
      telefono: "",
      city: "",
      postCode: "",
      address: "",
      shop: "",
      telf: "",
      }; 
    }

    async presentLoading() {
      this.loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'guardando...',
      });
      await this.loading.present();  
    }

    async presentToast(msg: string) {
      const toast = await this.toastController.create({
        message: msg,
        duration: 2000,
        color: 'light',
      });
      toast.present();
    }
 

}
